
<template>
  <div class="contact-page">
    <div class="contact-header">
      <h1>联系我们</h1>
      <p>有任何问题或建议，请随时与我们联系</p>
    </div>

    <div class="contact-content">
      <div class="contact-info">
        <div class="info-card">
          <i class="el-icon-phone"></i>
          <h3>电话咨询</h3>
          <p>400-155-1068</p>
        </div>
        <div class="info-card">
          <i class="el-icon-message"></i>
          <h3>邮件联系</h3>
          <p>dingli@jobhand.cn</p>
        </div>
<!--        <div class="info-card">-->
<!--          <i class="el-icon-location"></i>-->
<!--          <h3>地址</h3>-->
<!--          <p>山东省济南市舜华路2000号舜泰广场2号楼16F</p>-->
<!--        </div>-->
      </div>

      <div class="contact-form-wrapper">
        <el-form
            :model="form"
            :rules="rules"
            ref="contactForm"
            label-width="100px"
            class="contact-form"
        >
          <el-form-item label="姓名" prop="xingming">
            <el-input v-model="form.xingming" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="youxiang">
            <el-input v-model="form.youxiang" placeholder="请输入您的邮箱"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="sjh">
            <el-input v-model="form.sjh" placeholder="请输入您的电话"></el-input>
          </el-form-item>
          <el-form-item label="留言内容" prop="lynr">
            <el-input
                type="textarea"
                v-model="form.lynr"
                :rows="5"
                placeholder="请输入您的留言内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
                type="primary"
                @click="submitForm"
            >提交留言</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        xingming:'',
        sjh:'',
        youxiang:'',
        lynr:'',
      },
      rules: {
        xingming: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        sjh: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {  pattern: /^1[3-9]\d{9}$/,  message: '请输入正确的手机号', trigger: ['blur'] }
        ],
        youxiang: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        lynr: [
          { required: true, message: '请输入留言内容', trigger: 'blur' },
        ]
      },
      fwcishu:0
    }
  },
  created() {
    this.tongji('联系我们');
  },
  methods: {
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    submitForm() {
      this.$refs.contactForm.validate(valid => {
        if (valid) {
          // 这里替换为实际的API调用
          var that = this;
          this.$ajax
              .post(this.GLOBAL.sys_addr + '/lianxiwomen/tLianxiwomen/add',this.form)
              .then(function (response) {
                if (response.data.code == 200) {
                  that.$notify.success({ position: 'bottom-right', title: '提示', message: '提交成功！我们会尽快与您联系' });
                } else {
                  that.$notify.warning({ position: 'bottom-right', title: '提示', message: response.data.msg });
                }
              });
        }
      })
    }
  }
}
</script>

<style scoped>
.contact-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}
.contact-header {
  text-align: center;
  margin-bottom: 50px;
}
.contact-header h1 {
  font-size: 36px;
  color: #333;
  margin-bottom: 15px;
}
.contact-header p {
  font-size: 16px;
  color: #666;
}
.contact-content {
  display: flex;
  gap: 40px;
}
.contact-info {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.info-card {
  background: #f9f9f9;
  padding: 25px;
  border-radius: 8px;
  text-align: center;
  transition: all 0.3s;
}
.info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}
.info-card i {
  font-size: 36px;
  color: #409EFF;
  margin-bottom: 15px;
}
.info-card h3 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #333;
}
.info-card p {
  font-size: 14px;
  color: #666;
}
.contact-form-wrapper {
  flex: 1;
}
.contact-form {
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
@media (max-width: 992px) {
  .contact-content {
    flex-direction: column;
  }
  .contact-info {
    grid-template-columns: 1fr;
  }
}
</style>
